import { render, staticRenderFns } from "./personalBasicInfo.vue?vue&type=template&id=7799c7c5&scoped=true&"
import script from "./personalBasicInfo.vue?vue&type=script&lang=js&"
export * from "./personalBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./personalBasicInfo.vue?vue&type=style&index=0&id=7799c7c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7799c7c5",
  null
  
)

export default component.exports